<template>
    <div v-if="isLoading" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Loading">Loading...
    </div>
    <div v-else>
        <div style="margin-top: 20px; margin-bottom: 10px;">
            <RankSelect @changeType="changeType"></RankSelect>
        </div>
        <div style="display: flex; justify-content: center;">
            <Section illust_title="排行榜" :imageData="imageInfos_new"></Section>
        </div>
    </div>

    <div style="display: flex; justify-content: center;">
        <paginater :count="count" :type="1"></paginater>
    </div>
</template>
<script>
import { ref } from 'vue'
import Section from '@/components/Section copy.vue';
import paginater from '@/components/paginater.vue';
import RankSelect from '@/components/RankSelect.vue';

export default {
    name: 'Rank',
    data() {
        return {
            isLoading: true,
            fullscreenLoading: ref(true),
            imageInfos_new: [],
            count: 8,
            type: 0
        }
    },
    components: {
        Section,
        paginater,
        RankSelect,
    },
    async created() {
        try {
            await this.loadData(0);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            this.isLoading = false;
        }
        // this.loadData(0);
    },
    methods: {
        async loadData(offset) {
            this.date = this.$route.query.date;
            this.type = this.$route.query.type;
            await this.$axios.get("https://www.vilipix.com/api/v1/picture/ranking?type=" + this.type + "&ranking_date=" + this.date + "&limit=30&offset=" + offset * 30).then(res => {
                this.imageInfos_new = res.data.data.rows;
                this.count = res.data.data.count;
            }).catch(error => {
                console.log(error);
            })
        },

        pageChange(offset) {
            this.loadData(offset);
            console.log(offset);
        },
    },
    watch: {
        '$route'(to, from) {
            this.loadData(0);
        }
    }
}
</script>